module.exports = __webpack_public_path__ + "static/media/defendersR6NoBackground.7d350ae4.png";